import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import { FreeMode } from "swiper/modules";
import ContentLoader from "react-content-loader";
import Classes from "./Routes.module.css";
import EmployeeColumn from "./components/EmployeeColumn";

export default function RoutesSlider({ loading, employees, setEmployees, handleopenReschedulePopup, handleOpenUpdateStatusPopup,
  onMove,
  allEmployees,
}) {
  const skeleton = useMemo(
    () => (
      <Swiper slidesPerView={3} spaceBetween={15} className="mySwiper">
        {[...Array(4)].map((_, i) => (
          <SwiperSlide key={i} className={Classes.swiperElem}>
            <ContentLoader height="89vh" width="22rem">
              <rect x="0" y="0" rx="15" ry="15" width="100%" height="100%" />
            </ContentLoader>
          </SwiperSlide>
        ))}
      </Swiper>
    ),
    []
  );

  if (loading) return skeleton;

  return (
    <Swiper
      slidesPerView={3}
      spaceBetween={15}
      freeMode
      modules={[FreeMode]}
      className="mySwiper"
      breakpoints={{ 480: { slidesPerView: 1, spaceBetween: 10 }, 900: { slidesPerView: 3, spaceBetween: 15 }, 1280: { slidesPerView: 4, spaceBetween: 15 }, 1536: { slidesPerView: 5, spaceBetween: 15 } }}
    >
      {(employees || []).map((col) => (
        <SwiperSlide key={col.id} className={Classes.swiperElem}>
          <div className={Classes.card}>
            <div className="flexBetween mb-10">
    <div>
      <h5 className={Classes.stageTitle}>{col.name}</h5>
      <div className={Classes.colTotals}>
        Sales: {col.totalBookings || '0.00'} | Earnings: ${col.totalEarnings?.toFixed(2) || '0.00'}
      </div>
    </div>
  </div>

            <div className={Classes.cardInner}>
              {col.appointments.length === 0 ? (
                <div className={Classes.emptyColumn}><p>No appointments</p></div>
              ) : (
                col.appointments.map((appt, i) => (
                  <React.Fragment key={appt.id}>
                    <EmployeeColumn.AppointmentCard
                      columnId={col.id}
                      appt={appt}
                      onStatusChange={(status) => {
                        setEmployees((prev) =>
                          prev.map((c) =>
                            c.id !== col.id
                              ? c
                              : { ...c, appointments: c.appointments.map((a) => (a.id === appt.id ? { ...a, status } : a)) }
                          )
                        );
                      }}
                      handleopenReschedulePopup={() => handleopenReschedulePopup(appt)}
                      handleOpenUpdateStatusPopup={() => handleOpenUpdateStatusPopup(appt)}
                      onMove={onMove}               // ⬅️ NEW
                      allEmployees={allEmployees}   // ⬅️ NEW
                    />
                    {i < col.appointments.length - 1 && <div className={Classes.connector} aria-hidden />}
                  </React.Fragment>
                ))
              )}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
